import { render, staticRenderFns } from "./allApproval.vue?vue&type=template&id=0dbd5443&scoped=true&"
import script from "./allApproval.vue?vue&type=script&lang=js&"
export * from "./allApproval.vue?vue&type=script&lang=js&"
import style0 from "./allApproval.vue?vue&type=style&index=0&id=0dbd5443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd5443",
  null
  
)

export default component.exports